import classNames from "classnames";
import React from "react";
import styles from "../../styles/Form.module.css";
import PulseLoader from "../Loader/PulseLoader";

interface ButtonProps {
  addon?: string;
  asLink?: boolean;
  children?: JSX.Element | string;
  className?: string;
  color?: "red" | "transparent" | "primaryText" | "ignore" | "primaryColor";
  disabled?: boolean;
  inverse?: boolean;
  loading?: boolean;
  onClick?: () => void;
  pulseColor?: string;
  rounded?: boolean;
  small?: boolean;
  style?: React.CSSProperties;
  textColorClass?: string;
  type?: "submit" | "button" | "reset" | undefined;
  widthClass?: string;
}

function Button({
  addon,
  asLink = false,
  children,
  className,
  color = "primary",
  disabled = false,
  inverse = false,
  loading = false,
  onClick,
  pulseColor = "",
  rounded = true,
  small = false,
  style = {},
  textColorClass,
  type = "submit",
  widthClass = "w-auto",
}: ButtonProps): JSX.Element {
  const content = loading ? (
    <div className="relative">
      <div className="invisible">{children}</div>
      <PulseLoader
        className="absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
        color={pulseColor}
        size={1.5}
      />
    </div>
  ) : (
    children
  );

  if (!asLink) {
    style.backgroundImage =
      "linear-gradient(to top right, rgba(255,255,255,0), rgba(255,255,255,0.3)), linear-gradient(to top left, rgba(255,255,255,0), rgba(255,255,255,0.15)), linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.05))";
  }

  return (
    <button
      aria-label={content}
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={classNames(
        asLink ? styles.link : styles.button,
        className,
        inverse ? styles.inverse : styles.normal,
        inverse ? "" : styles[color || ""],
        {
          "rounded-md": rounded,
          "py-2 px-8": !addon && !asLink,
          [`shadow-md ${widthClass ? widthClass : "w-full"}`]: !asLink,
        },
        `sm:${widthClass}`,
        "flex border border-transparent sm:order-last",
      )}
      style={style}
    >
      <div
        className={classNames(
          { "py-2 px-8": addon, "text-sm": small },
          textColorClass,
          "font-medium flex-1",
        )}
      >
        {content}
      </div>
      {addon && (
        <div className="h-full px-4 py-2 font-light font-number bg-white/25 rounded-r-md">
          {addon}
        </div>
      )}
    </button>
  );
}

export default Button;
